import { notFound } from '@tanstack/react-router'
import Request from '@src/services/api/Request'

/** Loads a product's CMS page by slug, throwing notFound when none exists. */
export async function loadProductPage(slug: string) {
  const technologyPage = (await Request.technologies(slug)) || []
  const pageData = technologyPage[0]?.attributes ?? null

  if (!pageData) {
    throw notFound()
  }

  return { pageData }
}
